import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.confs = [{
      img: require('@/assets/images/conf-app.png'),
      subject: '应用服务分会场',
      desc: '从渠道到平台，今天的vivo已具备更加完善的多环节服务能力，在过往的基础上我们再次升级平台支持能力和效率，连接时代和需求，构建更丰富的应用分发服务生态。打造爆款从来不止靠流量，因为我们不只有流量。'
    }, {
      img: require('@/assets/images/conf-game.png'),
      subject: '游戏生态分会场',
      desc: '我们深知一款好的游戏并不容易打造——策划、调试、优化、修改，我们不希望无数个日夜的付出变成一场数字游戏，所以我们有了调优能力，有了数据能力，有了运营能力，有了平台服务能力，还有了我们自己的品牌力。比起昙花一现，我们更看好稳步向前。'
    }, {
      img: require('@/assets/images/conf-business.png'),
      subject: '商业合作分会场',
      desc: '营销讲求角度、广度、深度，对行业蓝海的洞察，对商业市场的覆盖，以及对产品和行业的全周期理解。而vivo也将聚集更多的资源与力量，在已有的努力之上，提供更具前瞻性的服务。希望我们不仅仅是您的营销合作方，而是您的营销顾问。'
    }, {
      img: require('@/assets/images/conf-tech.png'),
      subject: '技术开放分会场',
      desc: '开放、效率、升级，这三个词便是分会场的关键，但我们不仅仅关注技术的发展和进步，我们希望回到最初的原点，让技术更贴近产业诉求，让技术成为生活的解决方案，让技术不再是畅想未来的遥不可及，而是活在当下的美与喜悦。'
    }, {
      img: require('@/assets/images/conf-iot.png'),
      subject: 'IoT开放生态分会场',
      desc: '从终端到家居，从衣食到住行，这一年来vivo并没有推出生活电器，但我们联通了更多的智能家居；这一年来vivo虽没有涉足出行，但我们让你的驾驶体验更加随心。正如我们的目标一样，我们来连接生活，你只需享受生活。'
    }];
    return _this;
  }

  return Index;
}(Vue);

Index = __decorate([Component({
  name: 'ViewIntro',
  components: {}
})], Index);
export default Index;